export default "__VITE_ASSET__DaXGZC8L__"